export const getGeoSelectedCookieName = () => "MDRNA_GEO_SELECTED";

export const getHCPConfirmedCookieName = () => "MDRNA_HCP_CONFIRMED";

export const deleteGeoSelectedCookie = () => {
  document.cookie = `${getGeoSelectedCookieName()}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const deleteHCPConfirmedCookie = () => {
  document.cookie = `${getHCPConfirmedCookieName()}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
